import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Setting } from '../../App';
import { useAddress } from '../../hooks/use-address';
import './style.css';

export const Address: FC<{ setting: Setting }> = ({ setting }) => {
  const {
    subscription,
    formRef,
    redirectToShowPage,
    setSubscription,
    changeCountry,
    validateDeliveryAddress,
    validationErrors,
    submit,
  } = useAddress(setting);

  if (!subscription) {
    return <></>;
  }

  if (!subscription.shop.showChangeAddress) {
    redirectToShowPage();

    return <></>;
  }

  const countryOptions = subscription.countries.map((country, i) => (
    <option key={i} value={country.code}>
      {country.name}
    </option>
  ));

  const provinceOptions = subscription.country.zones.map((zone, i) => (
    <option key={i} value={zone.code}>
      {zone.name}
    </option>
  ));

  return (
    <div className="huckleberry-subscription-address">
      <h2>配送住所を編集する</h2>
      <form ref={formRef}>
        <div className="container-wrap">
          <div className="container last-name">
            <label className="address-label">姓</label>
            <input
              className="address-input"
              type="text"
              required
              onChange={(event) =>
                setSubscription({
                  ...subscription,
                  deliveryLastName: event.target.value,
                })
              }
              value={subscription.deliveryLastName ?? ''}
            />
          </div>

          <div className="container first-name">
            <label className="address-label">名</label>
            <input
              className="address-input"
              type="text"
              required
              onChange={(event) =>
                setSubscription({
                  ...subscription,
                  deliveryFirstName: event.target.value,
                })
              }
              value={subscription.deliveryFirstName ?? ''}
            />
          </div>
        </div>

        <div className="container country">
          <label className="address-label">国/地域</label>
          <div className="select-wrap">
            <select
              className="address-input"
              onChange={(event) => {
                changeCountry(event.target.value);
              }}
              value={subscription.deliveryCountryCode ?? ''}
            >
              {countryOptions}
            </select>
            <svg aria-hidden="true" focusable="false" viewBox="0 0 10 6">
              <use href="#huckleberry-icon-caret"></use>
            </svg>
          </div>
        </div>

        <div className="container zip">
          <label className="address-label">郵便番号</label>
          <input
            className="address-input"
            type="text"
            required
            onChange={(event) => {
              setSubscription({
                ...subscription,
                deliveryZip: event.target.value,
              });
            }}
            onBlur={async () => await validateDeliveryAddress()}
            value={subscription.deliveryZip ?? ''}
          />
          {validationErrors.postalCode ? <div className="error-message">{validationErrors.postalCode}</div> : <></>}
        </div>

        <div className="container prefecture">
          <label className="address-label">都道府県</label>
          <div className="select-wrap">
            <select
              className="address-input"
              onChange={(event) => {
                setSubscription({
                  ...subscription,
                  deliveryProvinceCode: event.target.value,
                });

                validateDeliveryAddress({ provinceCode: event.target.value });
              }}
              value={subscription.deliveryProvinceCode ?? ''}
            >
              {provinceOptions}
            </select>
            <svg aria-hidden="true" focusable="false" viewBox="0 0 10 6">
              <use href="#huckleberry-icon-caret"></use>
            </svg>
          </div>
          {validationErrors.prefecture ? <div className="error-message">{validationErrors.prefecture}</div> : <></>}
        </div>

        <div className="container city">
          <label className="address-label">市区町村</label>
          <input
            className="address-input"
            type="text"
            required
            onChange={(event) =>
              setSubscription({
                ...subscription,
                deliveryCity: event.target.value,
              })
            }
            onBlur={async () => await validateDeliveryAddress()}
            value={subscription.deliveryCity ?? ''}
          />
          {validationErrors.city ? <div className="error-message">{validationErrors.city}</div> : <></>}
        </div>

        <div className="container address1">
          <label className="address-label">住所</label>
          <input
            className="address-input"
            type="text"
            required
            onChange={(event) =>
              setSubscription({
                ...subscription,
                deliveryAddress1: event.target.value,
              })
            }
            onBlur={async () => await validateDeliveryAddress()}
            value={subscription.deliveryAddress1 ?? ''}
          />
          {validationErrors.address ? <div className="error-message">{validationErrors.address}</div> : <></>}
        </div>

        <div className="container address2">
          <label className="address-label">建物名、部屋番号 (任意)</label>
          <input
            className="address-input"
            type="text"
            onChange={(event) =>
              setSubscription({
                ...subscription,
                deliveryAddress2: event.target.value,
              })
            }
            value={subscription.deliveryAddress2 ?? ''}
          />
        </div>

        <div className="container company">
          <label className="address-label">会社名</label>
          <input
            className="address-input"
            type="text"
            onChange={(event) =>
              setSubscription({
                ...subscription,
                deliveryCompany: event.target.value,
              })
            }
            value={subscription.deliveryCompany ?? ''}
          />
        </div>

        <div className="container phone">
          <label className="address-label">電話番号</label>
          <input
            className="address-input"
            type="text"
            onChange={(event) =>
              setSubscription({
                ...subscription,
                deliveryPhone: event.target.value,
              })
            }
            value={subscription.deliveryPhone ?? ''}
          />
        </div>

        <div className="container-wrap buttons">
          <div className="container update-button">
            <button className="address-button" onClick={submit} type="submit" disabled={subscription.disabled}>
              更新
            </button>
          </div>
          <div className="container cancel-button">
            <Link
              className="address-button"
              to={`/subscriptions/${encodeURIComponent(subscription.subscriptionContractId)}`}
            >
              キャンセル
            </Link>
          </div>
        </div>
      </form>
    </div>
  );
};
